import { jsx as _jsx } from "react/jsx-runtime";
import { Box, UnorderedList } from '@chakra-ui/react';
/**
 * Navigation element used for listing links or navigation-related actions.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/navigation-list
 */
export function NavigationList({ children, ...props }) {
    return (_jsx(Box, { as: "nav", ...props, children: _jsx(UnorderedList, { m: 0, listStyleType: "none", children: children }) }));
}
//# sourceMappingURL=navigation-list.js.map